import { createContext, ReactNode, useContext } from "react";

import { useFilterActivity } from "./filter-activity.hook";

const FilterActivityContext = createContext(
  {} as ReturnType<typeof useFilterActivity>
);
export function useFilterActivityContext() {
  return useContext(FilterActivityContext);
}

interface FilterActivityProviderProps {
  children: ReactNode;
}
export function FilterActivityProvider({
  children,
}: FilterActivityProviderProps) {
  return (
    <FilterActivityContext.Provider value={useFilterActivity()}>
      {children}
    </FilterActivityContext.Provider>
  );
}